"use strict";
var Observable_1 = require('../../Observable');
var last_1 = require('../../operator/last');
Observable_1.Observable.prototype.last = last_1.last;
//# sourceMappingURL=last.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/last.js